/* eslint-disable @typescript-eslint/naming-convention */
import { MotorTorqueCurvesID } from 'src/api';

export const motorTorque: MotorTorqueCurvesID = {
  data_id: '',
  component_type: 'MotorTorqueCurveID',
};
